import TemplateModal from './TemplateModal';

export default TemplateModal;
